import { sdk } from 'src/utilities/sdk';

export const getEnableUniversalAccountsEndpoint = (corpId: string): string =>
  `/corp-admin/corp/${corpId}/universal_accounts`;

export async function enableUniversalAccounts(corpId: string): Promise<void> {
  await sdk.http.post(getEnableUniversalAccountsEndpoint(corpId), {});
}
